import React from 'react';
import SchemaDropdownMenu from '../../../components/SchemaDropdownMenu';
import { pluralize } from '../../../utils/formatText';
import styled from 'styled-components';
import { GlobalCategories } from '../../../components/Categories';
import { useDictionarySearchParamsEffect } from '../../../utils/searchParamsDataSharing';
import SearchInput from '../../../components/Form/SearchInput';
import ThinDivider from '../../../components/ThinDivider';
import { IEntityCategoryFieldsFragment } from '../../../utils/apollo/graphqlSchema';

interface IProps {
  selectedSchemaId: string;
  searchQuery: string;
  setSearchQuery: (searchQuery: string) => void;
  title: string;
  dictionaryItemCount: number;
  // if undefined, ignore the permitted schema Ids
  permittedSchemaIds?: string[];
  onApplyTags?: (
    selectedCategories: string[],
    isManaged: boolean,
  ) => Promise<void>;
  isPermittedToAssignCategory: boolean;
  showApplyTags?: boolean;
  selectedEntities?: Array<{ categories: IEntityCategoryFieldsFragment[] }>;
}

const HeaderRow = styled.div`
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
`;

const HeaderRowLeft = styled.div`
  display: flex;
  align-items: center;
  column-gap: 16px;
`;

const DictionaryHeader = ({
  selectedSchemaId,
  searchQuery,
  setSearchQuery,
  title,
  dictionaryItemCount,
  permittedSchemaIds,
  onApplyTags,
  isPermittedToAssignCategory,
  showApplyTags = false,
  selectedEntities = [],
}: IProps) => {
  // populate schemaId + search term from search params data sharing
  useDictionarySearchParamsEffect(setSearchQuery);

  const onChangeSchema = () => {
    if (searchQuery?.length !== 0) {
      setSearchQuery('');
    }
  };

  return (
    <>
      <HeaderRow>
        <HeaderRowLeft>
          <SchemaDropdownMenu
            value={selectedSchemaId}
            onChange={onChangeSchema}
            permittedSchemaIds={permittedSchemaIds}
          />
          {showApplyTags && onApplyTags && (
            <>
              <ThinDivider layout="vertical" size="short" />
              <GlobalCategories
                schemaId={selectedSchemaId}
                onApply={onApplyTags}
                isPermittedToAssignCategory={isPermittedToAssignCategory}
                selectedEntities={selectedEntities}
              />
            </>
          )}
        </HeaderRowLeft>

        <SearchInput
          placeholder={`Search ${dictionaryItemCount} ${pluralize(
            title,
            dictionaryItemCount,
          )}`}
          onChange={setSearchQuery}
          value={searchQuery}
        />
      </HeaderRow>
    </>
  );
};

export default DictionaryHeader;
